import { GenerateModalWithSuspense } from "@libs/modal-panels/modal-registry-helpers";
import { iModalProps } from "@libs/modal-panels/modal-registry-model";
import React from "react";

const QCTranscriptModal = React.lazy(() => import("./qc-transcript.modal"));

const QCTranscript: iModalProps<
  typeof QCTranscriptModal,
  {
    conversationId: string;
  }
> = {
  name: "qc-transcript",
  component: GenerateModalWithSuspense(QCTranscriptModal),
};

export default QCTranscript;
